function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 157L80 127L130 121L183 85H237L302 9",
  stroke: "#10CFAB",
  strokeWidth: 3
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 7,
  cy: 156,
  r: 7,
  fill: "#10CFAB"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 303,
  cy: 7,
  r: 7,
  fill: "#10CFAB"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 310,
    height: 163,
    viewBox: "0 0 310 163",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/child-labor-graph.e5f6bf55.svg";
export { SvgComponent as ReactComponent };